import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import UpIcon from "@mui/icons-material/ArrowUpwardOutlined";
import DownIcon from "@mui/icons-material/ArrowDownwardOutlined";
import {
  Box,
  Tooltip,
  CircularProgress,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Popover,
  Icon,
  Badge,
} from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import DeleteConfirmationModal from "../deleteConfirmationModal";
import { isMobile } from "../../globalStyles/mobile";
import SupplierDetailsModal from "../supplier-details-modal";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SortingIcon from "../../globalStyles/icons/sorting-icon";
import FilterModal from "../filterModal";
import { useTheme } from "@mui/styles";
import ViewIcon from "../../globalStyles/icons/vieewIcon";
import EditIcon from "../../globalStyles/icons/editIcon";
import TableHeader from "../table-header";
import DemandProfileDetailsModal from "../DemandProfileDetailsModal";
import DeleteIcon from "../../globalStyles/icons/deleteIcon";
import { demandProfileService } from "../../utils/services/demandProfileService";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--table-header-bg)",
    padding: "6px",
    textAlign: "start",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "4px",
    textAlign: "start",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "var(--bg-paper)",
    border: "1px solid var(--border-color)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "var(--row-bg-even)",
    border: "1px solid var(--border-color)",
  },

  "&:lastChild td, &:lastChild th": {
    border: 0,
  },
}));

const DemandProfileTableCell = ({
  demandProfile,
  handleViewClick,
  handleEditClick,
  clientId,
  handleDeleteClick,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const handleActionClick = (action) => {
    handlePopoverClose();
    switch (action) {
      case "view":
        handleViewClick(demandProfile);
        break;
      case "edit":
        handleEditClick(demandProfile);
        break;
      case "delete":
        handleDeleteClick(demandProfile);
        break;
      default:
        break;
    }
  };

  return (
    <Box>
      <IconButton
        aria-label="more actions"
        onClick={handlePopoverOpen}
        sx={{
          color: open ? "primary.main" : "inherit",
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", padding: 1 }}>
          <Button
            onClick={() => handleActionClick("view")}
            sx={{ textTransform: "none", justifyContent: "flex-start" }}
          >
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <ViewIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                color={"var(--text-tertiary)"}
                fontWeight={500}
              >
                View
              </Typography>
            </Box>
          </Button>
          {clientId ? (
            <></>
          ) : (
            <Button
              onClick={() => handleActionClick("edit")}
              sx={{ textTransform: "none", justifyContent: "flex-start" }}
            >
              <Box display={"flex"} gap={1} alignItems={"center"}>
                <EditIcon />
                <Typography
                  fontFamily={"poppins"}
                  fontSize={"16px"}
                  color={"var(--text-tertiary)"}
                  fontWeight={500}
                >
                  Edit
                </Typography>
              </Box>
            </Button>
          )}
          <IconButton
            onClick={() => handleActionClick("delete")}
            title="Delete"
          >
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <DeleteIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                color={"var(--text-tertiary)"}
                fontWeight={500}
              >
                Delete
              </Typography>
            </Box>
          </IconButton>
        </Box>
      </Popover>
    </Box>
  );
};
const DemandProfileList = ({
  client,
  data,
  onEditData,
  onDeleteData,
  viewMode,
  selectedDemandProfile,
  setSelectedDemandProfile,
  onChangeFilter,
  filterData,
  currentPage,
  itemsPerPage,
  clientId,
}) => {
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [selectedDemandProfileData, setSelectedDemandProfileData] = useState(
    [],
  );
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme.palette?.primary?.main || defaultColor;
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [selectedFilterKey, setSelectedFilterKey] = useState("");
  const [anchorElFilter, setAnchorElFilter] = useState(null);
  const [selectedfilterData, setSelectedFilterData] = useState({
    key: "",
    name: "",
    filter: [],
    sort: 0,
    id: "_id",
    displayKey: "name",
    fetchApi: () => {},
    options: [],
    loadMoreButton: false,
    searchKey: "",
  });
  const startIndex = currentPage * itemsPerPage;
  const handleOpenFilter = (event, filterKey) => {
    setAnchorElFilter(event.currentTarget);
    setSelectedFilterKey(filterKey);
    setOpenFilterModal(true);
    setSelectedFilterData(
      filterData?.columns.find((x) => x?.key === filterKey),
    );
  };
  const handleSaveFilter = (
    selectedOptions,
    filterKey,
    sortOrder,
    searchKey,
  ) => {
    onChangeFilter({
      key: filterKey,
      filter: selectedOptions,
      sort: sortOrder,
      searchKey: searchKey,
    });
    handleCloseFilter();
  };

  const handleCloseFilter = () => {
    setAnchorElFilter(null);
    setOpenFilterModal(false);
  };

  const confirmDelete = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await demandProfileService.delete(selectedDemandProfile._id);
      onDeleteData();
      setOpenConfirmation(false);
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewClick = (demandProfile) => {
    setSelectedDemandProfile(demandProfile);
    setOpenViewModal(true);
  };
  const handleDeleteClick = (demandProfile) => {
    setSelectedDemandProfile(demandProfile);
    setOpenConfirmation(true);
  };

  useEffect(() => {
    setSelectedDemandProfileData(
      data?.map((demandProfile) => ({
        ...demandProfile,
        action: (
          <DemandProfileTableCell
            demandProfile={demandProfile}
            handleViewClick={handleViewClick}
            handleEditClick={onEditData}
            clientId={clientId}
            handleDeleteClick={handleDeleteClick}
          />
        ),
      })),
    );
  }, [data]);

  const getNestedValue = (obj, path) => {
    if (!obj || !path) return undefined;
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
  };
  const NoDataImage = () => (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <img
        src="no_data_product.png"
        alt="No data available"
        style={{ objectFit: "cover", height: "300px" }}
      />
    </div>
  );
  const renderGridView = () => (
    <Grid
      sx={{
        marginTop: "1px",
        maxHeight: "100%",
        paddingBottom: 5,
        overflow: "auto",
      }}
      container
      spacing={2}
    >
      {selectedDemandProfileData?.map((demandProfile, index) => (
        <Grid sx={{ paddingBottom: 1 }} item xs={12} sm={6} md={4} key={index}>
          <Card
            sx={{
              boxShadow: 3,
              cursor: "pointer",
              width: "100%",
              height: "100%",
              position: "relative",
              borderRadius: "6px",
              border: "1px solid var(--border-color)",
            }}
          >
            <CardContent>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  fontWeight="500"
                  sx={{ textAlign: "start" }}
                  fontFamily="Poppins"
                  color="var(--text-tertiary)"
                >
                  {startIndex + index + 1}
                </Typography>
                <div
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                  }}
                >
                  {demandProfile?.action}
                </div>
              </div>
              <Grid container spacing={1} mt={2}>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="var(--text-tertiary)"
                  >
                    ITEM
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    : {demandProfile?.item}
                  </Typography>
                </Grid>
                {["q1_units", "q2_units", "q3_units", "q4_units"].map(
                  (q, i) => (
                    <React.Fragment key={q}>
                      <Grid item xs={5} display="flex" alignItems="center">
                        <Typography
                          fontWeight="500"
                          sx={{ textAlign: "start" }}
                          fontFamily={"poppins"}
                          color={"var(--text-tertiary)"}
                        >
                          {q.toUpperCase().replace("_UNITS", " UNITS")}
                        </Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography
                          noWrap
                          sx={{ textAlign: "start" }}
                          fontWeight="500"
                          fontFamily={"poppins"}
                          color={"var(--text-tertiary)"}
                        >
                          : {demandProfile?.[q]}
                        </Typography>
                      </Grid>
                    </React.Fragment>
                  ),
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const TableSchema = [
    {
      key: "sl_no",
      title: "SL NO",
      render: (item, index) => (
        <Typography
          fontSize="12px"
          color="var(--text-secondary)"
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {startIndex + index + 1}
        </Typography>
      ),
    },
    {
      key: "item",
      title: "ITEM",
      displayKey: "item",
    },
    ...["q1_units", "q2_units", "q3_units", "q4_units"].map((q) => ({
      key: q,
      title: q.toUpperCase().replace("_UNITS", " UNITS"),
      render: (item) => (
        <Typography
          fontSize="12px"
          color="var(--text-secondary)"
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {item[q]}%
        </Typography>
      ),
    })),
    { key: "action", title: "", width: "3%", displayKey: "action" },
  ];

  const renderListView = () => (
    <div
      style={{
        width: "100%",
        overflow: isMobile() ? "auto" : "hidden",
        paddingBottom: 20,
        marginTop: 5,
      }}
    >
      {isMobile() ? (
        renderGridView()
      ) : (
        <TableContainer
          sx={{
            overflowY: "auto",
            paddingInline: 0.4,
            maxHeight: "100%",
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              border: "1px solid var(--border-color)",
            }}
          >
            <TableHead
              sx={{
                backgroundColor: "var(--table-header-bg) !important",
                "& th": { backgroundColor: "var(--table-header-bg)" },
              }}
            >
              <StyledTableRow>
                {TableSchema.map((column) => (
                  <TableHeader
                    key={column.key}
                    column={column}
                    filterData={filterData}
                    filterKey={column.filterKey}
                    handleOpenFilter={column.handleOpenFilter}
                    title={column.title}
                  />
                ))}
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {selectedDemandProfileData.length === 0 ? (
                <StyledTableRow>
                  <TableCell colSpan={8} align="center">
                    <NoDataImage />
                  </TableCell>
                </StyledTableRow>
              ) : (
                selectedDemandProfileData?.map((x, rowIndex) => (
                  <StyledTableRow
                    sx={{
                      "&:hover": { backgroundColor: "var(--hover-bg-color)" },
                      height: 48,
                    }}
                    key={rowIndex}
                  >
                    {TableSchema.map((column, colIndex) => (
                      <StyledTableCell
                        key={column.key || colIndex}
                        sx={{ width: column.width }}
                      >
                        {column.displayKey ? (
                          <Typography
                            fontSize="12px"
                            color="var(--text-secondary)"
                            fontWeight={400}
                            fontFamily={"Poppins"}
                          >
                            {x[column.displayKey]}
                          </Typography>
                        ) : (
                          column.render(x, rowIndex)
                        )}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );

  return (
    <div sx={{ minWidth: "100%" }}>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <div
          style={{
            overflowY: "scroll",
            display: "flex",
            maxHeight: isMobile()
              ? `calc(100vh - 210px)`
              : `calc(100vh - 250px)`,
            width: "100%",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::WebkitScrollbar": { width: 0 },
          }}
        >
          {viewMode === "grid" ? renderGridView() : renderListView()}
        </div>
      )}

      <DeleteConfirmationModal
        DeleteConfirmationModal
        title={`Are you sure you want to delete ${selectedDemandProfile?.item} ?`}
        open={openConfirmation}
        handleClose={() => setOpenConfirmation(false)}
        handleDelete={(e) => confirmDelete(e)}
      />

      <DemandProfileDetailsModal
        demandProfile={selectedDemandProfile}
        open={openViewModal}
        onClose={() => setOpenViewModal(false)}
      />
    </div>
  );
};

export default DemandProfileList;
